<script>
  import MoneyCard from './cards/money-card.svelte';
  import RateCard from './cards/rate-card.svelte';
  import ChartCard from './cards/chart-card.svelte';
  import {Row, Col} from "sveltestrap";
  import {getStats} from "../modules/api-client";

  let data = {};

  async function config() {
    data = await getStats();
  }

  config();
</script>

<div class="container-fluid">
    <!-- Page Heading -->
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
        <h1 class="h3 mb-0 text-gray-800">Dashboard</h1>
    </div>

    <Row>
        <Col>
            <Row>
                <div class="d-sm-flex align-items-center justify-content-between mb-4">
                    <h1 class="h4 mb-0 text-gray-800">Current Month</h1>
                </div>
                <Col xl="6" md="12" class="mb-4">
                    <MoneyCard title="Earnings" ico="fas fa-solid fa-dollar-sign fa-2x text-gray-300" color="success" value={data.currentMonth?.earnings}/>
                </Col>
                <Col xl="6" md="12" class="mb-4">
                    <RateCard title="Goal" ico="fas fa-solid fa-user fa-2x text-gray-300" color="success" value={data.currentMonth?.goal}/>
                </Col>
            </Row>
        </Col>
        <Col>
            <Row>
                <div class="d-sm-flex align-items-center justify-content-between mb-4">
                    <h1 class="h4 mb-0 text-gray-800">Last Month</h1>
                </div>
                <Col xl="6" md="12" class="mb-4">
                    <MoneyCard title="Earnings" ico="fas fa-solid fa-dollar-sign fa-2x text-gray-300" color="primary" value={data.lastMonth?.earnings}/>
                </Col>
                <Col xl="6" md="12" class="mb-4">
                    <RateCard title="Goal" ico="fas fa-solid fa-user fa-2x text-gray-300" color="primary" value={data.lastMonth?.goal}/>
                </Col>
            </Row>
        </Col>
    </Row>

    <Row>
        <Col>
            <Row>
                <div class="d-sm-flex align-items-center justify-content-between mb-4">
                    <h1 class="h4 mb-0 text-gray-800">Last Quarter</h1>
                </div>
                <Col xl="6" md="12" class="mb-4">
                    <MoneyCard title="Earnings" ico="fas fa-solid fa-dollar-sign fa-2x text-gray-300" color="warning" value={data.lastQuarter?.earnings}/>
                </Col>
                <Col xl="6" md="12" class="mb-4">
                    <MoneyCard title="IVA" ico="fas fa-solid fa-landmark fa-2x text-gray-300" color="warning" value={data.lastQuarter?.iva}/>
                </Col>
            </Row>
        </Col>
        <Col>
            <Row>
                <div class="d-sm-flex align-items-center justify-content-between mb-4">
                    <h1 class="h4 mb-0 text-gray-800">Last Year</h1>
                </div>
                <Col xl="6" md="12" class="mb-4">
                    <MoneyCard title="Earnings" ico="fas fa-solid fa-dollar-sign fa-2x text-gray-300" color="info" value={data.lastYear?.earnings}/>
                </Col>
                <Col xl="6" md="12" class="mb-4">
                    <MoneyCard title="IRPF" ico="fas fa-solid fa-landmark fa-2x text-gray-300" color="info" value="{data.lastYear?.irpf}"/>
                </Col>
            </Row>
        </Col>
    </Row>

    <Row>
        <div class="d-sm-flex align-items-center justify-content-between mb-4">
            <h1 class="h4 mb-0 text-gray-800">History</h1>
        </div>
        <Col xl="9" md="12" class="mb-4">
            <ChartCard title="Earnings History" color="primary" value={data.history?.earnings}/>
        </Col>
        <Col xl="3" md="12" class="mb-4">
            <Row>
                <Col class="mb-4">
                    <MoneyCard title="Earnings (Monthly)" ico="fas fa-calendar fa-2x text-gray-300" color="dark" value="40000"/>
                </Col>
            </Row>
            <Row>
                <Col class="mb-4">
                    <MoneyCard title="Earnings (Monthly)" ico="fas fa-calendar fa-2x text-gray-300" color="dark" value="40000"/>
                </Col>
            </Row>
        </Col>
    </Row>

</div>